import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {HubLoginFormResponse} from '../../model/hub-session';
import {HubApiService} from '../../services/hub-api.service';
import '@web.awesome.me/webawesome-pro/dist/components/icon/icon.js';
@Component({
  selector: 'hub-login-form-editor',
  imports: [FormsModule],
  templateUrl: './login-form-editor.component.html',
  styleUrl: './login-form-editor.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginFormEditorComponent implements OnInit {
  data: HubLoginFormResponse | null = null;
  activeLanguage = '';
  loading = true;
  error = '';
  success = '';

  constructor(private hubApi: HubApiService, private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.hubApi.loadLoginForm().subscribe({
      next: (data) => {
        this.data = data;
        this.activeLanguage = data.languages[0] || 'en';
        this.loading = false;
      },
      error: (error) => {
        this.error = error.error?.message || this.t('HubLoginFormLoadFailedMessage');
        this.loading = false;
      }
    });
  }

  save(): void {
    if (!this.data) return;
    this.error = '';
    this.success = '';
      this.hubApi.saveLoginForm(this.data.translations).subscribe({
      next: (data) => {
        this.data = data;
        this.success = this.t('HubLoginFormSavedMessage');
      },
      error: (error) => this.error = error.error?.message || this.t('HubLoginFormSaveFailedMessage')
    });
  }

  copyEmbedCode(): void {
    if (!this.data?.embedCode) return;
    this.error = '';
    this.success = '';
    if (!navigator.clipboard) {
      this.error = this.t('HubClipboardUnavailableMessage');
      return;
    }
    navigator.clipboard.writeText(this.data.embedCode).then(() => {
      this.success = this.t('HubEmbedCodeCopiedMessage');
    }).catch(() => {
      this.error = this.t('HubEmbedCodeCopyFailedMessage');
    });
  }

  previewUrl(language: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl((this.data?.previewBaseUrl || '') + encodeURIComponent(language));
  }

  t(key: string): string {
    return this.hubApi.translate(key) || key;
  }
}
